import React, { useEffect, useState } from "react";

import { authConfig, applyStyles } from "../../utils/auth";
import { Spin } from "antd";
import { authProject, removeItem, getDns } from "utils";
import { useParams } from "react-router-dom";

import history from "../../services/history";

import { ArrowLeftOutlined } from "@ant-design/icons";
import PdfViewer from "../../components/PdfViewer";

export default function File(props) {
  const [returnToken, setReturnToken] = useState(true);
  const [url, setUrl] = useState("");
  const [logo, setLogo] = useState("");

  const { dns, type } = useParams();

  const titleType = {
    privacyPolicy: "Política de Privacidade",
    termsConditions: "Termos de Uso",
  };

  useEffect(() => {
    removeItem("tk-project");
    removeItem("tk-user");
    removeItem("userEmail");
    removeItem("userPhone");
    removeItem("userId");
    removeItem("privacyPolicy");
    removeItem("termsRepresentation");
    removeItem("termsConditions");
    removeItem("companyId");
    removeItem("androidAppUrl");
    removeItem("companyName");
    removeItem("iosAppUrl");

    var subdomain = window.location.hostname;

    if (window.location.hostname === "localhost") {
      subdomain = "brm1";
    } else {
      subdomain = subdomain.match(/embed-(.*?)\./)[1];
    }

    applyStyles(subdomain).then(() =>
      authProject(authConfig).then(() => setReturnToken(false))
    );

    async function getUrl() {
      const { data: productDns } = await getDns({
        dns,
      });

      setLogo(productDns[0].stylesheet["image-logo"]);
      setUrl(productDns[0].assets[type]);
    }
    getUrl();
  }, []);

  return (
    <div style={{ textAlign: "center" }}>
      {returnToken ? (
        <div className="d-flex vw-100 vh-100 align-items-center justify-content-center">
          <Spin tip="Carregando ambiente" spinning={returnToken} />
        </div>
      ) : (
        <>
          <div className="__auth-policy-header">
            <div className="__auth-header-logo" style={{ flexWrap: "wrap" }}>
              <img
                src={logo}
                style={{
                  width: "150px",
                  height: "fit-content",
                  alignSelf: "center",
                }}
              />
              {titleType[type] && (
                <h1 className="__auth-header-title">{titleType[type]}</h1>
              )}
            </div>
          </div>
          <div className="__auth-policy-content">
            <PdfViewer url={url}></PdfViewer>
          </div>
        </>
      )}
    </div>
  );
}
